import { MentoringCreateForm } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Shared/MentoringCreateForm';
import { useCreateMentor } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateMentor';
import type {
  CustomAttributeType,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface CreateMentorProps {
  program: Program;
  attributes: CustomAttributeType[];
  onSuccess: () => void;
  applicationDescription: string;
  title: string;
}

export const CreateMentor = ({
  program,
  attributes,
  applicationDescription,
  title,
  onSuccess,
}: CreateMentorProps) => {
  const { mutateAsync, isPending } = useCreateMentor(program);

  return (
    <>
      {isPending && <LockScreen />}
      <MentoringCreateForm
        attributes={attributes}
        applicationDescription={applicationDescription}
        title={title}
        onSuccess={onSuccess}
        onCreate={mutateAsync}
      />
    </>
  );
};
